// @ts-ignore
import("./bootstrap");
